import {
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
  UpdateParams,
  UpdateResult,
} from 'react-admin';
import IHandler from './IHandler';
import { getJson, postJson, putJson } from '../../../utils/api';

const getChangedData = (
  data: Record<string, any>,
  previousData: Record<string, any>,
): Record<string, any> => {
  const changedData: Record<string, any> = {};

  for (const key in data) {
    if (data[key] === null && data[key] !== previousData[key]) {
      changedData[key] = data[key];
      // eslint-disable-next-line no-continue
      continue;
    }

    if (typeof data[key] === 'object') {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (data[key] !== previousData[key]) {
      changedData[key] = data[key];
    }
  }

  return changedData;
};

export default class UserListHandler implements IHandler {
  static prevNextToken: Record<number, string> = {};

  static route = '/admin/user';

  static async getListHandler<RecordType extends RaRecord = any>(
    _?: string,
    params?: GetListParams,
  ): Promise<GetListResult<RecordType>> {
    const query: { [key: string]: any } = {
      limit: params?.pagination.perPage ?? 100,
      ...params?.filter,
    };

    const page = params?.pagination.page ?? 1;
    if (page > 1 && UserListHandler.prevNextToken[page - 1] != null) {
      query.nextToken = UserListHandler.prevNextToken[page - 1];
    }

    return postJson(
      `${this.route}/search`,
      query,
      process.env.REACT_APP_ADMIN_API_BASE_URL,
    )
      .then(async (response) => {
        let { data: responseData } = await response.json();
        const nextToken = responseData?.nextToken;
        UserListHandler.prevNextToken[page] = JSON.stringify(nextToken);
        responseData = responseData?.users?.map((data: any) => {
          const result = {
            ...data,
          };

          return {
            ...result,
          };
        });
        return {
          data: responseData,
          pageInfo: {
            hasNextPage: !!nextToken,
            nextPageToken: nextToken ?? undefined,
          },
        };
      })
      .catch((response) => {
        if (response.status === 400) {
          return {
            data: [],
            total: 0,
          };
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          status: response.status,
          error: response.statusText,
          message: response.statusText,
        });
      });
  }

  static async getOneHandler<RecordType extends RaRecord = any>(
    _: string,
    params?: GetOneParams,
  ): Promise<GetOneResult<RecordType>> {
    const id = params?.id;
    return getJson(
      `${this.route}/${id}`,
      process.env.REACT_APP_ADMIN_API_BASE_URL,
    ).then(async (response) => {
      const { data } = await response.json();

      return {
        data: {
          ...data,
        },
      };
    });
  }

  static async updateHandler<RecordType extends RaRecord = any>(
    _: string,
    params?: UpdateParams<any>,
  ): Promise<UpdateResult<RecordType>> {
    const payload = params?.data || {};
    const previousPayload = params?.previousData || {};
    const changedData = getChangedData(payload, previousPayload);

    return putJson(`${this.route}/${params?.id}`, changedData).then(
      async (response) => {
        const { data } = await response.json();

        return {
          data: {
            ...data,
          },
        };
      },
    );
  }
}
